/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Per-survey readiness shown on the Review Survey Status step (step 2). Taken purely from the new survey's DataHub displayLoadStatus (mirrors the survey-list Status column): LOADED → available, IN_PROGRESS → processing, AWAITING_VENDOR → awaitingVendorMaterials, EMPTY/UNDER_REVIEW → awaitingData. `awaitingVendorMaterials` is the customer choosing "wait until Bettercomp has it" in the Add Survey wizard — Bettercomp still has to source the vendor's data. It is not vendor entitlement pre-verification; that state has no contract value yet. NOTE: `failed` is kept in the enum for a forward-complete contract but is NOT emitted yet — displayLoadStatus has no FAILED value. `UNDER_REVIEW` folds into awaitingData for now.
 */
export enum SurveySeasonSurveyReviewStatus {
    AVAILABLE = 'available',
    AWAITING_DATA = 'awaitingData',
    PROCESSING = 'processing',
    FAILED = 'failed',
    AWAITING_VENDOR_MATERIALS = 'awaitingVendorMaterials',
}
